import { mapBookClubDispatchProducts } from "../selectors/mapBookClubDispatchProducts.js";
import { fetchSubscriptionItem } from "./fetchSubscriptionItem.js";
export const getBookClubDispatchProducts = async ({ sku }, { client }) => {
    const subscription = await fetchSubscriptionItem(sku, { client });
    return mapBookClubDispatchProducts(subscription);
};
